import React, { useEffect } from 'react'
import { closeLoginModal, openLoginModal } from 'redux/slices/loginModal'

import { Route } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
//Local modules
import { useAuth0 } from 'libs/web-client/utils/auth0/src'

const GuardedRoute = ({ openLoginModal, closeLoginModal, ...rest }) => {
    const { isAuthenticated } = useAuth0()

    useEffect(() => {
        if (!isAuthenticated) {
            openLoginModal({ canClose: false })
        } else {
            closeLoginModal()
        }
    })

    return <Route {...rest} />
}

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            openLoginModal,
            closeLoginModal,
        },
        dispatch,
    )

export default connect(undefined, mapDispatchToProps)(GuardedRoute)
